"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasLoader = void 0;
var _priceutils = require("../utils/priceutils");
var _PricingResourceClient = require("../apis/PricingResourceClient");
var _pricingResource = require("../constants/pricingResource");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PasLoader = /*#__PURE__*/function () {
  function PasLoader() {
    var client = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _PricingResourceClient.PricingResourceClient();
    _classCallCheck(this, PasLoader);
    this.client = client;
  }
  _createClass(PasLoader, [{
    key: "getPrices",
    value: function () {
      var _getPrices = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(accessToken, itemId) {
        var priceAssociationsData, priceAssociations, customerProductPricePriceAssociations, customerShippingPricePriceAssociations, transferProductPricePriceAssociations, transferShippingPricePriceAssociations, manufacturingProductCostPriceAssociations, transferProductPrice, customerProductPrice, customerShippingPrice, transferShippingPrice, manufacturingProductCost;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.client.getPriceAssociations(accessToken, itemId);
              case 2:
                priceAssociationsData = _context.sent;
                priceAssociations = priceAssociationsData._embedded.priceAssociations;
                customerProductPricePriceAssociations = (0, _priceutils.filterAndSortPriceAssociations)(priceAssociations, _pricingResource.priceAssociationTypes.customerProductPrice);
                customerShippingPricePriceAssociations = (0, _priceutils.filterAndSortPriceAssociations)(priceAssociations, _pricingResource.priceAssociationTypes.customerShippingPrice);
                transferProductPricePriceAssociations = (0, _priceutils.filterAndSortPriceAssociations)(priceAssociations, _pricingResource.priceAssociationTypes.transferProductPrice);
                transferShippingPricePriceAssociations = (0, _priceutils.filterAndSortPriceAssociations)(priceAssociations, _pricingResource.priceAssociationTypes.transferShippingPrice);
                manufacturingProductCostPriceAssociations = (0, _priceutils.filterAndSortPriceAssociations)(priceAssociations, _pricingResource.priceAssociationTypes.manufacturingProductCostType);
                transferProductPrice = (0, _priceutils.getTotalAmountFromPases)(transferProductPricePriceAssociations);
                customerProductPrice = (0, _priceutils.getTotalAmountFromPases)(customerProductPricePriceAssociations);
                customerShippingPrice = (0, _priceutils.getTotalAmountFromPases)(customerShippingPricePriceAssociations);
                transferShippingPrice = (0, _priceutils.getTotalAmountFromPases)(transferShippingPricePriceAssociations);
                manufacturingProductCost = (0, _priceutils.getTotalAmountFromPases)(manufacturingProductCostPriceAssociations);
                return _context.abrupt("return", {
                  customerProductPrice: customerProductPrice,
                  customerShippingPrice: customerShippingPrice,
                  transferShippingPrice: transferShippingPrice,
                  transferProductPrice: transferProductPrice,
                  manufacturingProductCost: manufacturingProductCost
                });
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getPrices(_x, _x2) {
        return _getPrices.apply(this, arguments);
      }
      return getPrices;
    }()
  }, {
    key: "getPriceWithSource",
    value: function () {
      var _getPriceWithSource = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(accessToken, itemId, priceAssociationsType) {
        var inflatedPriceAssociations;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getInflatedPriceAssociationsByType(accessToken, itemId, priceAssociationsType);
              case 2:
                inflatedPriceAssociations = _context2.sent;
                return _context2.abrupt("return", (0, _priceutils.aggregatePasData)(inflatedPriceAssociations));
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getPriceWithSource(_x3, _x4, _x5) {
        return _getPriceWithSource.apply(this, arguments);
      }
      return getPriceWithSource;
    }()
  }, {
    key: "getInflatedPriceAssociationsByType",
    value: function () {
      var _getInflatedPriceAssociationsByType = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(accessToken, itemId, priceAssociationsType) {
        var _this = this;
        var priceAssociationsData, priceAssociations, filteredPriceAssociations, promises;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.client.getPriceAssociations(accessToken, itemId);
              case 2:
                priceAssociationsData = _context3.sent;
                priceAssociations = priceAssociationsData._embedded.priceAssociations;
                filteredPriceAssociations = (0, _priceutils.filterAndSortPriceAssociations)(priceAssociations, priceAssociationsType);
                if (!(filteredPriceAssociations.length === 0)) {
                  _context3.next = 7;
                  break;
                }
                return _context3.abrupt("return", []);
              case 7:
                promises = filteredPriceAssociations.map(function (priceAssociation) {
                  return _this.inflatePriceAssociation(accessToken, priceAssociation);
                });
                _context3.next = 10;
                return Promise.all(promises);
              case 10:
                return _context3.abrupt("return", _context3.sent);
              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function getInflatedPriceAssociationsByType(_x6, _x7, _x8) {
        return _getInflatedPriceAssociationsByType.apply(this, arguments);
      }
      return getInflatedPriceAssociationsByType;
    }()
  }, {
    key: "inflatePriceAssociation",
    value: function () {
      var _inflatePriceAssociation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(accessToken, priceAssociation) {
        var _priceAssociation$_em, embeddedPrice, embeddedPriceError, _embeddedPriceError$_, _sourceResourceLink, sourceResponse, sourceResourceLink, priceSourceUrl, priceSourceData;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _priceAssociation$_em = priceAssociation._embedded, embeddedPrice = _priceAssociation$_em.price, embeddedPriceError = _priceAssociation$_em.priceError;
                if (!embeddedPriceError) {
                  _context4.next = 15;
                  break;
                }
                if (!((_embeddedPriceError$_ = embeddedPriceError._links) !== null && _embeddedPriceError$_ !== void 0 && _embeddedPriceError$_.source)) {
                  _context4.next = 14;
                  break;
                }
                _sourceResourceLink = embeddedPriceError._links.source;
                _context4.prev = 4;
                _context4.next = 7;
                return this.client.getResourceByHref(accessToken, _sourceResourceLink.href);
              case 7:
                sourceResponse = _context4.sent;
                return _context4.abrupt("return", _objectSpread(_objectSpread({}, priceAssociation), {}, {
                  price: null,
                  errors: [_objectSpread(_objectSpread({}, embeddedPriceError), {}, {
                    sourceError: sourceResponse
                  })]
                }));
              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](4);
                return _context4.abrupt("return", _objectSpread(_objectSpread({}, priceAssociation), {}, {
                  price: null,
                  errors: [embeddedPriceError, _context4.t0.response.data]
                }));
              case 14:
                return _context4.abrupt("return", _objectSpread(_objectSpread({}, priceAssociation), {}, {
                  price: null,
                  errors: [embeddedPriceError]
                }));
              case 15:
                sourceResourceLink = embeddedPrice._links.source;
                if (sourceResourceLink) {
                  _context4.next = 18;
                  break;
                }
                return _context4.abrupt("return", _objectSpread(_objectSpread({}, priceAssociation), {}, {
                  price: embeddedPrice
                }));
              case 18:
                priceSourceUrl = sourceResourceLink.href;
                _context4.prev = 19;
                _context4.next = 22;
                return this.client.getResourceByHref(accessToken, priceSourceUrl);
              case 22:
                priceSourceData = _context4.sent;
                return _context4.abrupt("return", _objectSpread(_objectSpread({}, priceAssociation), {}, {
                  price: embeddedPrice,
                  source: priceSourceData
                }));
              case 26:
                _context4.prev = 26;
                _context4.t1 = _context4["catch"](19);
                return _context4.abrupt("return", _objectSpread(_objectSpread({}, priceAssociation), {}, {
                  price: embeddedPrice,
                  errors: [_context4.t1.response.data]
                }));
              case 29:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 11], [19, 26]]);
      }));
      function inflatePriceAssociation(_x9, _x10) {
        return _inflatePriceAssociation.apply(this, arguments);
      }
      return inflatePriceAssociation;
    }()
  }]);
  return PasLoader;
}();
exports.PasLoader = PasLoader;